/* eslint-disable */
/* biome-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

/** Per-field type discriminator returned by the BE. `STRING + options` is
 *  collapsed to `ENUM` server-side; `key === "avatar"` is forced to AVATAR. */
export type VisitorProfileFieldType =
  | "AVATAR"
  | "STRING"
  | "NUMBER"
  | "BOOLEAN"
  | "DATE"
  | "ENUM"
  | "ARRAY";

/** One row in the visitor's Profile form — fully hydrated by the BE from
 *  `PeopleFieldDefinition` + `PeopleFieldValue` + the operator's allow-list.
 *  `value` is ALWAYS string-serialised on the wire; the widget parses /
 *  serialises per `type` (see the render switch in `ProfileTab`). */
export type VisitorProfileField = {
  /** Foreign key to `PeopleFieldDefinition.key`. Used as the React row key
   *  AND the diff key when writing back. */
  key: string;
  /** Operator-configured human label (e.g. "First name", "Workplace"). */
  label: string;
  type: VisitorProfileFieldType;
  /** Show a `*` asterisk + reject empty values when true. */
  required: boolean;
  /** Rendered DISABLED with a lock icon when true — operator (or the
   *  host's identified-visitor handshake) has set the value and the visitor
   *  isn't allowed to change it. */
  pinned: boolean;
  /** Option list for `ENUM` (`<select>` choices). Absent / empty for other
   *  types. */
  options?: string[] | null;
  /** Current value, string-serialised. The widget parses per `type`:
   *    NUMBER  → Number(value)
   *    BOOLEAN → value === 'true'
   *    DATE    → new Date(value)
   *    ARRAY   → JSON.parse(value)
   *    others  → as-is. */
  value?: string | null;
};

/** Visitor-controlled UI preferences exposed in the Profile tab. */
export type VisitorProfilePreferences = {
  /** Locale code (e.g. `"en"`, `"uk"`). Falls back to widget default when null. */
  language?: string | null;
  /** Opt-in for `Notification` API surfacing when the widget isn't focused. */
  desktopNotifications?: boolean | null;
  /** `LIGHT` / `DARK` / `AUTO`. Editable only when `themeModeEditable === true`. */
  themeMode?: string | null;
};

/** Server-resolved profile shape returned by `visitorProfile` and echoed by
 *  `updateVisitorProfile` after a write. */
export type VisitorProfile = {
  __typename?: 'VisitorProfile';
  /** Operator-allowed fields, in render order. Pinning is per-row. */
  fields: VisitorProfileField[];
  preferences: VisitorProfilePreferences;
  /** When `false`, the theme toggle MUST be disabled and the widget should
   *  fall back to `config.theme.themeMode` (ignore any local cached pref). */
  themeModeEditable: boolean;
};

/** One field-update entry. The BE re-parses `value` per the field's
 *  configured `type` and rejects mismatches with `peopleFields.invalidValue`. */
export type VisitorProfileFieldUpdate = {
  key: string;
  value: string;
};

/** Partial-update input for `updateVisitorProfile`. Send only fields the
 *  visitor edited; the BE rejects keys outside the operator allow-list with
 *  `webProfileFieldNotAllowed` and pinned keys with `webProfileFieldPinned`. */
export type UpdateVisitorProfileInput = {
  fields?: VisitorProfileFieldUpdate[];
  preferences?: {
    language?: string | null;
    desktopNotifications?: boolean | null;
    themeMode?: string | null;
  } | null;
};

export type VisitorProfileQueryVariables = Exact<Record<string, never>>;

export type VisitorProfileQuery = {
  __typename?: 'Query';
  visitorProfile: VisitorProfile;
};

/** Slim prefs-only variant — used by `useVisitorProfilePreferences`
 *  to drive theme/language/notifications on EVERY widget mount.
 *  Hand-patched per graphql-codegen-handpatch policy. */
export type VisitorProfilePreferencesQueryVariables = Exact<Record<string, never>>;

export type VisitorProfilePreferencesQuery = {
  __typename?: 'Query';
  visitorProfile: Pick<VisitorProfile, '__typename' | 'preferences' | 'themeModeEditable'>;
};

export type UpdateVisitorProfileMutationVariables = Exact<{
  input: UpdateVisitorProfileInput;
}>;

export type UpdateVisitorProfileMutation = {
  __typename?: 'Mutation';
  updateVisitorProfile: VisitorProfile;
};

export const VisitorProfilePreferencesDocument = gql`
    query VisitorProfilePreferences {
  visitorProfile {
    preferences {
      language
      desktopNotifications
      themeMode
    }
    themeModeEditable
  }
}
    `;

/**
 * __useVisitorProfilePreferencesQuery__
 *
 * Slim prefs-only query. Same `visitorProfile` resolver as the full
 * `VisitorProfile` query — both write into Apollo's parameterless
 * query slot, so opening ProfileTab supersedes the prefs read with
 * the full payload, and ProfileTab's save mutation flips the cache
 * for both consumers in one shot.
 */
export function useVisitorProfilePreferencesQuery(baseOptions?: Apollo.QueryHookOptions<VisitorProfilePreferencesQuery, VisitorProfilePreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitorProfilePreferencesQuery, VisitorProfilePreferencesQueryVariables>(VisitorProfilePreferencesDocument, options);
      }
export type VisitorProfilePreferencesQueryHookResult = ReturnType<typeof useVisitorProfilePreferencesQuery>;
export type VisitorProfilePreferencesQueryResult = Apollo.QueryResult<VisitorProfilePreferencesQuery, VisitorProfilePreferencesQueryVariables>;

export const VisitorProfileDocument = gql`
    query VisitorProfile {
  visitorProfile {
    fields {
      key
      label
      type
      required
      pinned
      options
      value
    }
    preferences {
      language
      desktopNotifications
      themeMode
    }
    themeModeEditable
  }
}
    `;

/**
 * __useVisitorProfileQuery__
 */
export function useVisitorProfileQuery(baseOptions?: Apollo.QueryHookOptions<VisitorProfileQuery, VisitorProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitorProfileQuery, VisitorProfileQueryVariables>(VisitorProfileDocument, options);
      }
export function useVisitorProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitorProfileQuery, VisitorProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitorProfileQuery, VisitorProfileQueryVariables>(VisitorProfileDocument, options);
        }
export type VisitorProfileQueryHookResult = ReturnType<typeof useVisitorProfileQuery>;
export type VisitorProfileLazyQueryHookResult = ReturnType<typeof useVisitorProfileLazyQuery>;
export type VisitorProfileQueryResult = Apollo.QueryResult<VisitorProfileQuery, VisitorProfileQueryVariables>;

export const UpdateVisitorProfileDocument = gql`
    mutation UpdateVisitorProfile($input: UpdateVisitorProfileInput!) {
  updateVisitorProfile(input: $input) {
    fields {
      key
      label
      type
      required
      pinned
      options
      value
    }
    preferences {
      language
      desktopNotifications
      themeMode
    }
    themeModeEditable
  }
}
    `;
export type UpdateVisitorProfileMutationFn = Apollo.MutationFunction<UpdateVisitorProfileMutation, UpdateVisitorProfileMutationVariables>;

/**
 * __useUpdateVisitorProfileMutation__
 */
export function useUpdateVisitorProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitorProfileMutation, UpdateVisitorProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitorProfileMutation, UpdateVisitorProfileMutationVariables>(UpdateVisitorProfileDocument, options);
      }
export type UpdateVisitorProfileMutationHookResult = ReturnType<typeof useUpdateVisitorProfileMutation>;
export type UpdateVisitorProfileMutationResult = Apollo.MutationResult<UpdateVisitorProfileMutation>;
export type UpdateVisitorProfileMutationOptions = Apollo.BaseMutationOptions<UpdateVisitorProfileMutation, UpdateVisitorProfileMutationVariables>;
